import styled from 'styled-components'

const PageContainer = styled.div`
  padding: 0.3rem 0.8rem;
`;

export default PageContainer
